export default __webpack_public_path__ + "static/image2-033c31b4304ac4148f8571e663b0ea00.jpg";